"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchProvinceNew = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var bankCard_1 = require("../../model/bankCard");
var service_1 = require("../../../library/base/service");
var SearchProvinceNew = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(SearchProvinceNew, _super);
    function SearchProvinceNew() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '获取省列表接口';
        _this.code = '101066';
        _this.desc = '获取省列表接口';
        _this.requestParams = new bankCard_1.SearchProvinceNewRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return SearchProvinceNew;
}(service_1.BaseService));
exports.SearchProvinceNew = SearchProvinceNew;
//# sourceMappingURL=searchProvinceNew.js.map